import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetAllStudentsUseCaseInterface } from 'domain/usecases';
import { IStudentsListFilters } from 'presentation/app/modules/Persons/Students/models/students-list-filters';

interface IStudentsListState {
  studentsListData: GetAllStudentsUseCaseInterface.Result;
  studentsListFilters: IStudentsListFilters;
}

interface IPayloadStudentsListData
  extends PayloadAction<GetAllStudentsUseCaseInterface.Result> {}

interface IPayloadStudentsListFilters
  extends PayloadAction<IStudentsListFilters> {}

const initialState: IStudentsListState = {
  studentsListData: null,
  studentsListFilters: null,
};

export const StudentsListSlice = createSlice({
  name: 'professionals-lists',
  initialState,
  reducers: {
    loadStudentsListData: (state, action: IPayloadStudentsListData) => {
      state.studentsListData = action.payload;
    },
    clearStudentsListData: (state) => {
      state.studentsListData = null;
    },
    loadStudentsListFilters: (state, action: IPayloadStudentsListFilters) => {
      state.studentsListFilters = action.payload;
    },
    clearStudentsListFilters: (state) => {
      state.studentsListFilters = null;
    },
  },
});

export const {
  loadStudentsListData,
  clearStudentsListData,
  loadStudentsListFilters,
  clearStudentsListFilters,
} = StudentsListSlice.actions;

export default StudentsListSlice.reducer;
